function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_75",
  "data-name": "Group 75",
  transform: "translate(8289.628 -7803.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_72",
  "data-name": "Group 72",
  transform: "translate(-8207.405 7893.635)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_271",
  "data-name": "Path 271",
  d: "M-8169.923,7910.069a22.524,22.524,0,0,0-22.523,22.523,22.523,22.523,0,0,0,22.523,22.523,22.523,22.523,0,0,0,22.523-22.523A22.548,22.548,0,0,0-8169.923,7910.069Zm0,41.875a19.353,19.353,0,0,1-19.353-19.353,19.353,19.353,0,0,1,19.353-19.353,19.352,19.352,0,0,1,19.353,19.353h0a19.372,19.372,0,0,1-19.353,19.353Z",
  transform: "translate(8192.446 -7910.069)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_272",
  "data-name": "Path 272",
  d: "M-8164.433,7933.842v-10.057a1.587,1.587,0,0,0-1.587-1.585,1.586,1.586,0,0,0-1.584,1.585V7934.5a1.648,1.648,0,0,0,.031.31c.01.051.028.1.043.148a1.377,1.377,0,0,0,.047.146,1.431,1.431,0,0,0,.093.178c.018.031.031.064.052.1a1.512,1.512,0,0,0,.2.247l4.271,4.271a1.586,1.586,0,0,0,2.242,0,1.585,1.585,0,0,0,0-2.242h0Z",
  transform: "translate(8188.542 -7911.975)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_74",
  "data-name": "Group 74",
  transform: "translate(-8287.628 7805.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_73",
  "data-name": "Group 73"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_273",
  "data-name": "Path 273",
  d: "M-8221.066,7868.344a34.616,34.616,0,0,1-23.789,9.375,34.61,34.61,0,0,1-23.788-9.375c-11.485,9.257-18.984,23.671-18.984,34.8,0,17.695,6.444,23.554,42.772,23.554s42.772-5.859,42.772-23.554C-8202.083,7892.016-8209.583,7877.6-8221.066,7868.344Z",
  transform: "translate(8287.628 -7815.376)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_24",
  "data-name": "Ellipse 24",
  cx: 27.304,
  cy: 27.304,
  r: 27.304,
  transform: "translate(15.468)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 4
}))));

var SvgSageIcon5 = function SvgSageIcon5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127.769,
    height: 135.682,
    viewBox: "0 0 127.769 135.682",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSageIcon5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sageIcon5.0092f162.svg";
export { ForwardRef as ReactComponent };